import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { StudentSkillStates } from '../../models/StudentSkillState';

export interface StudentSkillsForAllRoadmapsState {
  value: StudentSkillStates[] | null;
}

const initialState: StudentSkillsForAllRoadmapsState = { value: null };

export const studentSkillsForAllRoadmapsSlice = createSlice({
  name: 'studentSkillsForAllRoadmaps',
  initialState,
  reducers: {
    setStudentSkillsForAllRoadmaps: (
      state: StudentSkillsForAllRoadmapsState,
      action: PayloadAction<StudentSkillStates[]>,
    ) => {
      state.value = action.payload;
    },
  },
});

export const selectedStudentSkillStatesForAllRoadmaps = (state: RootState) => state.studentSkillsForAllRoadmaps.value;

export const { setStudentSkillsForAllRoadmaps } = studentSkillsForAllRoadmapsSlice.actions;

export default studentSkillsForAllRoadmapsSlice.reducer;
